/* tslint:disable */
/* eslint-disable */
/**
 * Navitia API - SNCF
 * Complete API documentation for Navitia/SNCF public transportation API. Based on https://doc.navitia.io
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '@/client/configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '@/client/common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '@/client/base';
// @ts-ignore
import type { CoverageCoverageCoordCoordFreefloatingsGet200Response } from '@/client/models';
// @ts-ignore
import type { POITypesResponse } from '@/client/models';
// @ts-ignore
import type { POIsResponse } from '@/client/models';
// @ts-ignore
import type { PlacesResponse } from '@/client/models';
// @ts-ignore
import type { StopAreasResponse } from '@/client/models';
/**
 * PlacesApi - axios parameter creator
 */
export const PlacesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Inverted geocoding - get address from coordinates
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageCoordCoordAddressesGet: async (coverage: string, coord: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageCoordCoordAddressesGet', 'coverage', coverage)
            // verify required parameter 'coord' is not null or undefined
            assertParamExists('coverageCoverageCoordCoordAddressesGet', 'coord', coord)
            const localVarPath = `/coverage/{coverage}/coord/{coord}/addresses`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)))
                .replace(`{${"coord"}}`, encodeURIComponent(String(coord)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freefloatings nearby coordinates
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
         * @param {number} [distance] Distance in meters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageCoordCoordFreefloatingsGet: async (coverage: string, coord: string, distance?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageCoordCoordFreefloatingsGet', 'coverage', coverage)
            // verify required parameter 'coord' is not null or undefined
            assertParamExists('coverageCoverageCoordCoordFreefloatingsGet', 'coord', coord)
            const localVarPath = `/coverage/{coverage}/coord/{coord}/freefloatings`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)))
                .replace(`{${"coord"}}`, encodeURIComponent(String(coord)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (distance !== undefined) {
                localVarQueryParameter['distance'] = distance;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find places (stop areas, stop points, addresses, POIs) within a certain distance from coordinates
         * @summary Find places nearby coordinates
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
         * @param {number} [distance] Distance in meters (default: 200)
         * @param {Array<CoverageCoverageCoordCoordPlacesNearbyGetTypeEnum>} [type] Filter by place types
         * @param {number} [count] Number of results to return
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageCoordCoordPlacesNearbyGet: async (coverage: string, coord: string, distance?: number, type?: Array<CoverageCoverageCoordCoordPlacesNearbyGetTypeEnum>, count?: number, depth?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageCoordCoordPlacesNearbyGet', 'coverage', coverage)
            // verify required parameter 'coord' is not null or undefined
            assertParamExists('coverageCoverageCoordCoordPlacesNearbyGet', 'coord', coord)
            const localVarPath = `/coverage/{coverage}/coord/{coord}/places_nearby`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)))
                .replace(`{${"coord"}}`, encodeURIComponent(String(coord)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (distance !== undefined) {
                localVarQueryParameter['distance'] = distance;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (depth !== undefined) {
                localVarQueryParameter['depth'] = depth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get points of interest within a certain distance from coordinates
         * @summary Get POIs nearby coordinates
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
         * @param {number} [distance] Distance in meters
         * @param {Array<string>} [poiTypes] Filter by POI type IDs (e.g., poi_type:amenity:bicycle_rental)
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageCoordCoordPoisGet: async (coverage: string, coord: string, distance?: number, poiTypes?: Array<string>, depth?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageCoordCoordPoisGet', 'coverage', coverage)
            // verify required parameter 'coord' is not null or undefined
            assertParamExists('coverageCoverageCoordCoordPoisGet', 'coord', coord)
            const localVarPath = `/coverage/{coverage}/coord/{coord}/pois`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)))
                .replace(`{${"coord"}}`, encodeURIComponent(String(coord)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (distance !== undefined) {
                localVarQueryParameter['distance'] = distance;
            }

            if (poiTypes) {
                localVarQueryParameter['poi_types'] = poiTypes;
            }

            if (depth !== undefined) {
                localVarQueryParameter['depth'] = depth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find stop areas within a certain distance from coordinates
         * @summary Find stop areas nearby coordinates
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
         * @param {number} [distance] Distance in meters (default: 200)
         * @param {number} [count] Number of results to return
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageCoordCoordStopAreasGet: async (coverage: string, coord: string, distance?: number, count?: number, depth?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageCoordCoordStopAreasGet', 'coverage', coverage)
            // verify required parameter 'coord' is not null or undefined
            assertParamExists('coverageCoverageCoordCoordStopAreasGet', 'coord', coord)
            const localVarPath = `/coverage/{coverage}/coord/{coord}/stop_areas`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)))
                .replace(`{${"coord"}}`, encodeURIComponent(String(coord)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (distance !== undefined) {
                localVarQueryParameter['distance'] = distance;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (depth !== undefined) {
                localVarQueryParameter['depth'] = depth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for places including stop areas, stop points, addresses, POIs, and administrative regions
         * @summary Search for places (geographical autocomplete)
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} q Search query (minimum 2 characters)
         * @param {number} [count] Number of results to return
         * @param {Array<CoverageCoveragePlacesGetTypeEnum>} [type] Filter by place types
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoveragePlacesGet: async (coverage: string, q: string, count?: number, type?: Array<CoverageCoveragePlacesGetTypeEnum>, depth?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoveragePlacesGet', 'coverage', coverage)
            // verify required parameter 'q' is not null or undefined
            assertParamExists('coverageCoveragePlacesGet', 'q', q)
            const localVarPath = `/coverage/{coverage}/places`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (depth !== undefined) {
                localVarQueryParameter['depth'] = depth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List POI types
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoveragePoiTypesGet: async (coverage: string, depth?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoveragePoiTypesGet', 'coverage', coverage)
            const localVarPath = `/coverage/{coverage}/poi_types`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (depth !== undefined) {
                localVarQueryParameter['depth'] = depth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlacesApi - functional programming interface
 */
export const PlacesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlacesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Inverted geocoding - get address from coordinates
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageCoordCoordAddressesGet(coverage: string, coord: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageCoordCoordAddressesGet(coverage, coord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacesApi.coverageCoverageCoordCoordAddressesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get freefloatings nearby coordinates
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
         * @param {number} [distance] Distance in meters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageCoordCoordFreefloatingsGet(coverage: string, coord: string, distance?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverageCoverageCoordCoordFreefloatingsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageCoordCoordFreefloatingsGet(coverage, coord, distance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacesApi.coverageCoverageCoordCoordFreefloatingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find places (stop areas, stop points, addresses, POIs) within a certain distance from coordinates
         * @summary Find places nearby coordinates
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
         * @param {number} [distance] Distance in meters (default: 200)
         * @param {Array<CoverageCoverageCoordCoordPlacesNearbyGetTypeEnum>} [type] Filter by place types
         * @param {number} [count] Number of results to return
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageCoordCoordPlacesNearbyGet(coverage: string, coord: string, distance?: number, type?: Array<CoverageCoverageCoordCoordPlacesNearbyGetTypeEnum>, count?: number, depth?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageCoordCoordPlacesNearbyGet(coverage, coord, distance, type, count, depth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacesApi.coverageCoverageCoordCoordPlacesNearbyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get points of interest within a certain distance from coordinates
         * @summary Get POIs nearby coordinates
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
         * @param {number} [distance] Distance in meters
         * @param {Array<string>} [poiTypes] Filter by POI type IDs (e.g., poi_type:amenity:bicycle_rental)
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageCoordCoordPoisGet(coverage: string, coord: string, distance?: number, poiTypes?: Array<string>, depth?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<POIsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageCoordCoordPoisGet(coverage, coord, distance, poiTypes, depth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacesApi.coverageCoverageCoordCoordPoisGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find stop areas within a certain distance from coordinates
         * @summary Find stop areas nearby coordinates
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
         * @param {number} [distance] Distance in meters (default: 200)
         * @param {number} [count] Number of results to return
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageCoordCoordStopAreasGet(coverage: string, coord: string, distance?: number, count?: number, depth?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StopAreasResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageCoordCoordStopAreasGet(coverage, coord, distance, count, depth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacesApi.coverageCoverageCoordCoordStopAreasGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for places including stop areas, stop points, addresses, POIs, and administrative regions
         * @summary Search for places (geographical autocomplete)
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} q Search query (minimum 2 characters)
         * @param {number} [count] Number of results to return
         * @param {Array<CoverageCoveragePlacesGetTypeEnum>} [type] Filter by place types
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoveragePlacesGet(coverage: string, q: string, count?: number, type?: Array<CoverageCoveragePlacesGetTypeEnum>, depth?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoveragePlacesGet(coverage, q, count, type, depth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacesApi.coverageCoveragePlacesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List POI types
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoveragePoiTypesGet(coverage: string, depth?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<POITypesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoveragePoiTypesGet(coverage, depth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacesApi.coverageCoveragePoiTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlacesApi - factory interface
 */
export const PlacesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlacesApiFp(configuration)
    return {
        /**
         * 
         * @summary Inverted geocoding - get address from coordinates
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageCoordCoordAddressesGet(coverage: string, coord: string, options?: RawAxiosRequestConfig): AxiosPromise<PlacesResponse> {
            return localVarFp.coverageCoverageCoordCoordAddressesGet(coverage, coord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freefloatings nearby coordinates
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
         * @param {number} [distance] Distance in meters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageCoordCoordFreefloatingsGet(coverage: string, coord: string, distance?: number, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageCoordCoordFreefloatingsGet200Response> {
            return localVarFp.coverageCoverageCoordCoordFreefloatingsGet(coverage, coord, distance, options).then((request) => request(axios, basePath));
        },
        /**
         * Find places (stop areas, stop points, addresses, POIs) within a certain distance from coordinates
         * @summary Find places nearby coordinates
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
         * @param {number} [distance] Distance in meters (default: 200)
         * @param {Array<CoverageCoverageCoordCoordPlacesNearbyGetTypeEnum>} [type] Filter by place types
         * @param {number} [count] Number of results to return
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageCoordCoordPlacesNearbyGet(coverage: string, coord: string, distance?: number, type?: Array<CoverageCoverageCoordCoordPlacesNearbyGetTypeEnum>, count?: number, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<PlacesResponse> {
            return localVarFp.coverageCoverageCoordCoordPlacesNearbyGet(coverage, coord, distance, type, count, depth, options).then((request) => request(axios, basePath));
        },
        /**
         * Get points of interest within a certain distance from coordinates
         * @summary Get POIs nearby coordinates
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
         * @param {number} [distance] Distance in meters
         * @param {Array<string>} [poiTypes] Filter by POI type IDs (e.g., poi_type:amenity:bicycle_rental)
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageCoordCoordPoisGet(coverage: string, coord: string, distance?: number, poiTypes?: Array<string>, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<POIsResponse> {
            return localVarFp.coverageCoverageCoordCoordPoisGet(coverage, coord, distance, poiTypes, depth, options).then((request) => request(axios, basePath));
        },
        /**
         * Find stop areas within a certain distance from coordinates
         * @summary Find stop areas nearby coordinates
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
         * @param {number} [distance] Distance in meters (default: 200)
         * @param {number} [count] Number of results to return
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageCoordCoordStopAreasGet(coverage: string, coord: string, distance?: number, count?: number, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<StopAreasResponse> {
            return localVarFp.coverageCoverageCoordCoordStopAreasGet(coverage, coord, distance, count, depth, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for places including stop areas, stop points, addresses, POIs, and administrative regions
         * @summary Search for places (geographical autocomplete)
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} q Search query (minimum 2 characters)
         * @param {number} [count] Number of results to return
         * @param {Array<CoverageCoveragePlacesGetTypeEnum>} [type] Filter by place types
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoveragePlacesGet(coverage: string, q: string, count?: number, type?: Array<CoverageCoveragePlacesGetTypeEnum>, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<PlacesResponse> {
            return localVarFp.coverageCoveragePlacesGet(coverage, q, count, type, depth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List POI types
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoveragePoiTypesGet(coverage: string, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<POITypesResponse> {
            return localVarFp.coverageCoveragePoiTypesGet(coverage, depth, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlacesApi - interface
 */
export interface PlacesApiInterface {
    /**
     * 
     * @summary Inverted geocoding - get address from coordinates
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageCoordCoordAddressesGet(coverage: string, coord: string, options?: RawAxiosRequestConfig): AxiosPromise<PlacesResponse>;

    /**
     * 
     * @summary Get freefloatings nearby coordinates
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
     * @param {number} [distance] Distance in meters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageCoordCoordFreefloatingsGet(coverage: string, coord: string, distance?: number, options?: RawAxiosRequestConfig): AxiosPromise<CoverageCoverageCoordCoordFreefloatingsGet200Response>;

    /**
     * Find places (stop areas, stop points, addresses, POIs) within a certain distance from coordinates
     * @summary Find places nearby coordinates
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
     * @param {number} [distance] Distance in meters (default: 200)
     * @param {Array<CoverageCoverageCoordCoordPlacesNearbyGetTypeEnum>} [type] Filter by place types
     * @param {number} [count] Number of results to return
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageCoordCoordPlacesNearbyGet(coverage: string, coord: string, distance?: number, type?: Array<CoverageCoverageCoordCoordPlacesNearbyGetTypeEnum>, count?: number, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<PlacesResponse>;

    /**
     * Get points of interest within a certain distance from coordinates
     * @summary Get POIs nearby coordinates
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
     * @param {number} [distance] Distance in meters
     * @param {Array<string>} [poiTypes] Filter by POI type IDs (e.g., poi_type:amenity:bicycle_rental)
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageCoordCoordPoisGet(coverage: string, coord: string, distance?: number, poiTypes?: Array<string>, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<POIsResponse>;

    /**
     * Find stop areas within a certain distance from coordinates
     * @summary Find stop areas nearby coordinates
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
     * @param {number} [distance] Distance in meters (default: 200)
     * @param {number} [count] Number of results to return
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageCoordCoordStopAreasGet(coverage: string, coord: string, distance?: number, count?: number, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<StopAreasResponse>;

    /**
     * Search for places including stop areas, stop points, addresses, POIs, and administrative regions
     * @summary Search for places (geographical autocomplete)
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} q Search query (minimum 2 characters)
     * @param {number} [count] Number of results to return
     * @param {Array<CoverageCoveragePlacesGetTypeEnum>} [type] Filter by place types
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoveragePlacesGet(coverage: string, q: string, count?: number, type?: Array<CoverageCoveragePlacesGetTypeEnum>, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<PlacesResponse>;

    /**
     * 
     * @summary List POI types
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoveragePoiTypesGet(coverage: string, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<POITypesResponse>;

}

/**
 * PlacesApi - object-oriented interface
 */
export class PlacesApi extends BaseAPI implements PlacesApiInterface {
    /**
     * 
     * @summary Inverted geocoding - get address from coordinates
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageCoordCoordAddressesGet(coverage: string, coord: string, options?: RawAxiosRequestConfig) {
        return PlacesApiFp(this.configuration).coverageCoverageCoordCoordAddressesGet(coverage, coord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freefloatings nearby coordinates
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
     * @param {number} [distance] Distance in meters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageCoordCoordFreefloatingsGet(coverage: string, coord: string, distance?: number, options?: RawAxiosRequestConfig) {
        return PlacesApiFp(this.configuration).coverageCoverageCoordCoordFreefloatingsGet(coverage, coord, distance, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find places (stop areas, stop points, addresses, POIs) within a certain distance from coordinates
     * @summary Find places nearby coordinates
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
     * @param {number} [distance] Distance in meters (default: 200)
     * @param {Array<CoverageCoverageCoordCoordPlacesNearbyGetTypeEnum>} [type] Filter by place types
     * @param {number} [count] Number of results to return
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageCoordCoordPlacesNearbyGet(coverage: string, coord: string, distance?: number, type?: Array<CoverageCoverageCoordCoordPlacesNearbyGetTypeEnum>, count?: number, depth?: number, options?: RawAxiosRequestConfig) {
        return PlacesApiFp(this.configuration).coverageCoverageCoordCoordPlacesNearbyGet(coverage, coord, distance, type, count, depth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get points of interest within a certain distance from coordinates
     * @summary Get POIs nearby coordinates
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
     * @param {number} [distance] Distance in meters
     * @param {Array<string>} [poiTypes] Filter by POI type IDs (e.g., poi_type:amenity:bicycle_rental)
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageCoordCoordPoisGet(coverage: string, coord: string, distance?: number, poiTypes?: Array<string>, depth?: number, options?: RawAxiosRequestConfig) {
        return PlacesApiFp(this.configuration).coverageCoverageCoordCoordPoisGet(coverage, coord, distance, poiTypes, depth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find stop areas within a certain distance from coordinates
     * @summary Find stop areas nearby coordinates
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} coord Coordinates in format \&#39;lon;lat\&#39;
     * @param {number} [distance] Distance in meters (default: 200)
     * @param {number} [count] Number of results to return
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageCoordCoordStopAreasGet(coverage: string, coord: string, distance?: number, count?: number, depth?: number, options?: RawAxiosRequestConfig) {
        return PlacesApiFp(this.configuration).coverageCoverageCoordCoordStopAreasGet(coverage, coord, distance, count, depth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for places including stop areas, stop points, addresses, POIs, and administrative regions
     * @summary Search for places (geographical autocomplete)
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} q Search query (minimum 2 characters)
     * @param {number} [count] Number of results to return
     * @param {Array<CoverageCoveragePlacesGetTypeEnum>} [type] Filter by place types
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoveragePlacesGet(coverage: string, q: string, count?: number, type?: Array<CoverageCoveragePlacesGetTypeEnum>, depth?: number, options?: RawAxiosRequestConfig) {
        return PlacesApiFp(this.configuration).coverageCoveragePlacesGet(coverage, q, count, type, depth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List POI types
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoveragePoiTypesGet(coverage: string, depth?: number, options?: RawAxiosRequestConfig) {
        return PlacesApiFp(this.configuration).coverageCoveragePoiTypesGet(coverage, depth, options).then((request) => request(this.axios, this.basePath));
    }
}

export const CoverageCoverageCoordCoordPlacesNearbyGetTypeEnum = {
    StopArea: 'stop_area',
    StopPoint: 'stop_point',
    Address: 'address',
    Poi: 'poi',
    AdministrativeRegion: 'administrative_region'
} as const;
export type CoverageCoverageCoordCoordPlacesNearbyGetTypeEnum = typeof CoverageCoverageCoordCoordPlacesNearbyGetTypeEnum[keyof typeof CoverageCoverageCoordCoordPlacesNearbyGetTypeEnum];
export const CoverageCoveragePlacesGetTypeEnum = {
    StopArea: 'stop_area',
    StopPoint: 'stop_point',
    Address: 'address',
    Poi: 'poi',
    AdministrativeRegion: 'administrative_region'
} as const;
export type CoverageCoveragePlacesGetTypeEnum = typeof CoverageCoveragePlacesGetTypeEnum[keyof typeof CoverageCoveragePlacesGetTypeEnum];
